/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link } from 'react-router-dom';

import tagManager from '../app/services/tagManager';
import {
  cartCleanItems, cartGetFile,
  cartSortItems, setDeliveryAddress,
  setObservation,
} from '../app/store/actions/cart';
import CartUtil from '../app/utils/cart';
import CartResume from '../components/cart/CartResume';
import CartTableItem from '../components/cart/CartTableItem';
import { Loading } from '../components/elements/Loading';
import { appendScript, removeScript, scrollToTopAnimated } from '../components/utils';
import ROUTES from '../data/routes';
import NUMBER from '../helpers/number';

class CartPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      view: 'products',
      taggedVisibleCart: false,
      defaultAddressOptionSelected: false,
      clientWithdrawAddressOptionSelected: false,
      clientWithdrawLockerAddressOptionSelected: false,
    };
  }

  componentDidMount = () => {
    setTimeout(() => {
      removeScript('/scripts/panel.min.js');
      appendScript('/scripts/panel.min.js');

      scrollToTopAnimated();

      this.sendTagManagerCheckoutStep(this.props.cartItems);

      if (!this.props.cartId) this.props.setDeliveryAddress('');
    }, 0);
  }

  componentWillUnmount = () => {
    removeScript('/scripts/panel.min.js');
  }

  componentDidUpdate = (prevProps, prevStates) => {
    const viewChanged = prevStates.view !== this.state.view;
    const changedCartItems = (prevProps.cartItems && this.props.cartItems) && prevProps.cartItems.length !== this.props.cartItems.length;

    if (viewChanged || changedCartItems) scrollToTopAnimated();

    this.sendTagManagerCheckoutStep(this.props.cartItems);
  }

  setView = async (view) => {
    await this.setState({ view });
  };

  sendTagManagerCheckoutStep = (cartItems = []) => {
    const {
      taggedVisibleCart,
    } = this.state;

    if (cartItems.length) {
      if (!taggedVisibleCart) {
        tagManager.ecommerceCheckoutSteps(
          cartItems.map(it => it.product || {}),
          1,
          'CartSummary',
        );

        this.setState({ taggedVisibleCart: true });
      }
    }
  }

  renderSolicitation = () => (
    <main>
      <div className="section section-panel">
        <div className="container">
          <div className="box-content">
            <div className="basket cart-status">
              <span className="cart-status-image" style={{ backgroundImage: 'url(/images/check.svg)' }} />
              <p style={{ textAlign: 'justify' }}>
                {`${I18n.t('cartSolicitationText')}`}
                <br />
                <span style={{ fontWeight: 'bold' }}>{I18n.t('cartSolicitationText2')}</span>
                {' '}
                {I18n.t('cartSolicitationText3')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  )

  renderEstimate = () => (
    <main>
      <div className="section section-panel">
        <div className="container">
          <div className="box-content">
            <div className="basket cart-status">
              <span className="cart-status-image" style={{ backgroundImage: 'url(/images/check.svg)' }} />
              <p>{I18n.t('cartEstimateText')}</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  )

  renderEmpty = () => (
    <main>
      <div className="section section-panel">
        <div className="container">
          <div className="box-content">
            <div className="basket cart-status">
              <span className="cart-status-image" style={{ backgroundImage: 'url(/images/carrinho-vazio.svg)' }} />
              <p style={{ fontSize: 'x-large' }}>{I18n.t('cartEmpty')}</p>
              <br />
              <br />
              <Link
                to={ROUTES.PRODUCTS}
                className="btn btn-outline-secondary"
              >
                {I18n.t('continueBuy')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </main>
  )

  setFreightCard = async (location) => {
    await this.props.setDeliveryAddress({
      address: {
        nameAbbr: location.nameAbbr,
        cep: location.cep,
        hasTax: location.hasTax,
        deliveryCode: location.deliveryCode || null,
      },
    });
  };

  setObservation = async (isLockerAddressSelected) => {
    const { observation } = this.props;

    if (isLockerAddressSelected) {
      if (observation.indexOf('Cliente Retira no LOCKER - ') < 0) await this.props.setObservation(`Cliente Retira no LOCKER - ${observation}`);
    } else {
      await this.props.setObservation(`${observation}`.replace('Cliente Retira no LOCKER - ', ''));
    }
  };

  setDeliveryAddress = async address => this.props.setDeliveryAddress(address);

  changeSelectedActiveStatus = async (optionSelectedLabel) => {
    if (optionSelectedLabel === 'defaultAddress') {
      await this.setState({
        defaultAddressOptionSelected: true,
        clientWithdrawAddressOptionSelected: false,
        clientWithdrawLockerAddressOptionSelected: false,
      });
    } else if (optionSelectedLabel === 'clientWithdraw') {
      await this.setState({
        defaultAddressOptionSelected: false,
        clientWithdrawAddressOptionSelected: true,
        clientWithdrawLockerAddressOptionSelected: false,
      });
    } else if (optionSelectedLabel === 'clientWithdrawLocker') {
      await this.setState({
        defaultAddressOptionSelected: false,
        clientWithdrawAddressOptionSelected: false,
        clientWithdrawLockerAddressOptionSelected: true,
      });
    } else {
      await this.setState({
        defaultAddressOptionSelected: false,
        clientWithdrawAddressOptionSelected: false,
        clientWithdrawLockerAddressOptionSelected: false,
      });
    }
  }

  renderProducts = ({
    cartItems,
    cartOrderBy,
    sortItems,
    pricePermission,
    leadTimePermission,
    stockPermission,
    opicCodePermission,
    soneparCodePermission,
    soneparCodeOff,
    fileEmailCsv,
    fileEmailPdf,
    fileEmailXml,
    fileEmailJson,
    companyTag,
    defaultAddress,
    locations,
    clientLocation,
    clientWithdraw,
    defaultAddressOptionSelected,
    clientWithdrawAddressOptionSelected,
    clientWithdrawLockerAddressOptionSelected,
    deliveryAddress,
    deliveryAddressType,
  }) => (
    <main>
      <div className="section section-panel">
        <div className="container">
          <h1 className="panel-title">{I18n.t('cartName')}</h1>
          <div className="panel-content" style={{ justifyContent: 'center' }}>
            <div className="box-content">
              <div className="basket">
                <div className="select select--grey">
                  <select
                    onChange={e => sortItems(e.target.value)}
                    value={cartOrderBy}
                  >
                    <option value="date-asc">{I18n.t('cartOrderByDateAsc')}</option>
                    <option value="date-desc">{I18n.t('cartOrderByDateDesc')}</option>
                    <option value="name-asc">{I18n.t('cartOrderByNameAsc')}</option>
                    <option value="name-desc">{I18n.t('cartOrderByNameDesc')}</option>
                  </select>
                </div>
                <div className="basket-title-product">
                  <div className="coll-01">{I18n.t('product')}</div>
                  <div className="coll-02" />
                  <div className="coll-03">{pricePermission ? I18n.t('price') : ''}</div>
                  <div className="coll-04">{I18n.t('quantity')}</div>
                  <div className="coll-05">{pricePermission ? I18n.t('subTotal') : ''}</div>
                </div>
                {cartItems.map((item, index) => (
                  <CartTableItem
                    key={item.product.id}
                    item={item}
                    pricePermission={pricePermission}
                    leadTimePermission={leadTimePermission}
                    stockPermission={stockPermission}
                    opicCodePermission={opicCodePermission}
                    soneparCodePermission={soneparCodePermission}
                    soneparCodeOff={soneparCodeOff}
                    clickPosition={index}
                  />
                ))}
                <div className="basket-buttons">
                  <Link
                    to={ROUTES.PRODUCTS}
                    className="btn"
                  >
                    {I18n.t('continueBuy')}
                  </Link>
                  {(fileEmailPdf || fileEmailCsv || fileEmailXml || fileEmailJson) && (
                    <div className="btn-drop cursorPointer">
                      {I18n.t('fileGenerate')}
                      <div className="drop">
                        {fileEmailPdf && (<a onClick={() => this.props.getFile('pdf')}>{I18n.t('pdf')}</a>)}
                        {fileEmailCsv && (<a onClick={() => this.props.getFile('csv')}>{I18n.t('csv')}</a>)}
                        {fileEmailXml && (<a onClick={() => this.props.getFile('xml')}>{I18n.t('xml')}</a>)}
                        {fileEmailJson && (<a onClick={() => this.props.getFile('json')}>{I18n.t('json')}</a>)}
                      </div>
                    </div>
                  )}
                  <a className="btn cursorPointer" onClick={this.props.cleanItems}>{I18n.t('cleanCart')}</a>
                </div>
              </div>
            </div>
            <div>
              <CartResume
                hasItems={cartItems.length > 0}
                subTotal={CartUtil.getCartTotal(cartItems, true, undefined, undefined, companyTag)}
                st={CartUtil.getCartSt(cartItems, companyTag)}
                setView={this.setView}
              />
              {this.props.cartId && this.props.purchasePermission && deliveryAddress && deliveryAddress.address && (
                <div className="cartAddressList" style={isMobile ? { marginLeft: '0px' } : {}}>
                  <div
                    className="basket-delivery active cartAddressList-address cartAddressList-address-active"
                    style={isMobile ? { width: 'auto' } : {}}
                    role="presentation"
                  >
                    {!deliveryAddress.address.isClient && !deliveryAddress.address.isLocker && (
                      <React.Fragment>
                        <div className="ico cartAddressList-iconContainer">
                          <svg className="icon icon-caminhao cartAddressList-iconImage">
                            <use xlinkHref="#icon-caminhao" />
                          </svg>
                        </div>
                        <div className="txt cartAddressList-textContainer">
                          <span className="txt-title cartAddressList-textTitle">{I18n.t('normalDelivery')}</span>
                          <p>{deliveryAddress.address.nameAbbr}</p>
                          <p>{deliveryAddress.address.address}</p>
                          <p>{deliveryAddress.address.province}</p>
                          <p>{`${deliveryAddress.address.city} - ${deliveryAddress.address.state}`}</p>
                          <p>{`${NUMBER.cepMask(deliveryAddress.address.cep)} - ${deliveryAddress.address.country}`}</p>
                        </div>
                      </React.Fragment>
                    )}
                    {(deliveryAddress.address.isClient || deliveryAddress.address.isLocker) && (
                      <React.Fragment>
                        <div className="ico cartAddressList-iconContainer">
                          <svg className="icon icon-fazer-compras cartAddressList-iconImage">
                            <use xlinkHref="#icon-fazer-compras" />
                          </svg>
                        </div>
                        <div className="txt cartAddressList-textContainer">
                          {deliveryAddress.address.isClient && (
                            <span className="txt-title cartAddressList-textTitle">{I18n.t('storeTake')}</span>
                          )}
                          {deliveryAddress.address.isLocker && (
                            <span className="txt-title cartAddressList-textTitle">{I18n.t('pickUpAtLockerStore')}</span>
                          )}
                          <p>{clientLocation.name}</p>
                          <p>{clientLocation.address}</p>
                          <p>{clientLocation.province}</p>
                          <p>{`${clientLocation.city} - ${clientLocation.state}`}</p>
                          <p>{`${NUMBER.cepMask(clientLocation.cep)} - ${clientLocation.country}`}</p>
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              )}
              {!this.props.cartId && !this.props.purchasePermission && deliveryAddressType && (
                <div className="cartAddressList" style={isMobile ? { marginLeft: '0px' } : {}}>
                  {defaultAddress && (
                    <div
                      className={
                        defaultAddressOptionSelected
                          ? 'basket-delivery active cursorPointer cartAddressList-address cartAddressList-address-active'
                          : 'basket-delivery active cursorPointer cartAddressList-address'
                      }
                      style={isMobile ? { width: 'auto' } : {}}
                      role="presentation"
                      onClick={() => {
                        this.setObservation(false);
                        this.setFreightCard(defaultAddress);
                        this.changeSelectedActiveStatus('defaultAddress');
                      }}
                    >
                      <div className="ico cartAddressList-iconContainer">
                        <svg className="icon icon-caminhao cartAddressList-iconImage"><use xlinkHref="#icon-caminhao" /></svg>
                      </div>
                      <div className="txt cartAddressList-textContainer">
                        <span className="txt-title cartAddressList-textTitle">{I18n.t('normalDelivery')}</span>
                        <p>{defaultAddress.nameAbbr}</p>
                        <p>{defaultAddress.address}</p>
                        <p>{defaultAddress.province}</p>
                        <p>{`${defaultAddress.city} - ${defaultAddress.state}`}</p>
                        <p>{`${NUMBER.cepMask(defaultAddress.cep)} - ${defaultAddress.country}`}</p>
                      </div>
                    </div>
                  )}
                  {locations.map(location => (
                    (!defaultAddress || location.cep !== defaultAddress.cep)
                      ? (
                        <React.Fragment key={location.deliveryCode}>
                          <div
                            className={
                              deliveryAddress.address
                              && deliveryAddress.address.deliveryCode
                              && location.deliveryCode === deliveryAddress.address.deliveryCode
                                ? 'basket-delivery cursorPointer cartAddressList-address cartAddressList-address-active'
                                : 'basket-delivery cursorPointer cartAddressList-address'
                            }
                            style={isMobile ? { width: 'auto' } : {}}
                            role="presentation"
                            onClick={() => {
                              this.setObservation(false);
                              this.setFreightCard(location);
                              this.changeSelectedActiveStatus();
                            }}
                          >
                            <div className="ico cartAddressList-iconContainer">
                              <svg className="icon icon-caminhao cartAddressList-iconImage"><use xlinkHref="#icon-caminhao" /></svg>
                            </div>
                            <div className="txt cartAddressList-textContainer">
                              <span className="txt-title cartAddressList-textTitle">{I18n.t('normalDelivery')}</span>
                              <p>{location.nameAbbr}</p>
                              <p>{location.address}</p>
                              <p>{location.province}</p>
                              <p>{`${location.city} - ${location.state}`}</p>
                              <p>{`${NUMBER.cepMask(location.cep)} - ${location.country}`}</p>
                            </div>
                          </div>
                        </React.Fragment>
                      )
                      : (
                        <React.Fragment />
                      )
                  ))}
                  {clientLocation && clientWithdraw && this.props.clientDetails.cartApprovalFlow !== 2 && (
                    <React.Fragment>
                      <div
                        className={
                          clientWithdrawAddressOptionSelected
                            ? 'basket-delivery active cursorPointer cartAddressList-address cartAddressList-address-active'
                            : 'basket-delivery active cursorPointer cartAddressList-address'
                        }
                        style={isMobile ? { width: 'auto' } : {}}
                        role="presentation"
                        onClick={() => {
                          this.setObservation(false);
                          this.setDeliveryAddress({ address: { isClient: true } });
                          this.changeSelectedActiveStatus('clientWithdraw');
                        }}
                      >
                        <div className="ico cartAddressList-iconContainer">
                          <svg className="icon icon-fazer-compras cartAddressList-iconImage"><use xlinkHref="#icon-fazer-compras" /></svg>
                        </div>
                        <div className="txt cartAddressList-textContainer">
                          <span className="txt-title cartAddressList-textTitle">{I18n.t('storeTake')}</span>
                          <p>{clientLocation.name}</p>
                          <p>{clientLocation.address}</p>
                          <p>{clientLocation.province}</p>
                          <p>{`${clientLocation.city} - ${clientLocation.state}`}</p>
                          <p>{`${NUMBER.cepMask(clientLocation.cep)} - ${clientLocation.country}`}</p>
                        </div>
                      </div>
                      <div
                        className={
                          clientWithdrawLockerAddressOptionSelected
                            ? 'basket-delivery active cursorPointer cartAddressList-address cartAddressList-address-active'
                            : 'basket-delivery active cursorPointer cartAddressList-address'
                        }
                        style={isMobile ? { width: 'auto' } : {}}
                        role="presentation"
                        onClick={() => {
                          this.setObservation(true);
                          this.setDeliveryAddress({ address: { isLocker: true } });
                          this.changeSelectedActiveStatus('clientWithdrawLocker');
                        }}
                      >
                        <div className="ico cartAddressList-iconContainer">
                          <svg className="icon icon-caminhao cartAddressList-iconImage"><use xlinkHref="#icon-caminhao" /></svg>
                        </div>
                        <div className="txt cartAddressList-textContainer">
                          <span className="txt-title cartAddressList-textTitle">{I18n.t('pickUpAtLockerStore')}</span>
                          <p>{clientLocation.name}</p>
                          <p>{clientLocation.address}</p>
                          <p>{clientLocation.province}</p>
                          <p>{`${clientLocation.city} - ${clientLocation.state}`}</p>
                          <p>{`${NUMBER.cepMask(clientLocation.cep)} - ${clientLocation.country}`}</p>
                        </div>
                      </div>
                    </React.Fragment>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </main>
  )

  render() {
    const {
      view,
      defaultAddressOptionSelected,
      clientWithdrawAddressOptionSelected,
      clientWithdrawLockerAddressOptionSelected,
    } = this.state;

    const {
      cartItems, cartOrderBy, sortItems,
      /* cartUser,  */cartLoaded, companyTag,
      pricePermission, leadTimePermission, stockPermission, clientDetails,
      opicCodePermission, soneparCodePermission, soneparCodeOff, defaultAddress,
      locations = [], clientLocation, clientWithdraw, deliveryAddress, deliveryAddressType,
    } = this.props;

    const {
      fileEmailCsv, fileEmailPdf, fileEmailXml, fileEmailJson,
    } = clientDetails;

    if (!cartLoaded) {
      return <Loading isLoading />;
    }

    if (view === 'solicitation') return this.renderSolicitation();
    if (view === 'estimate') return this.renderEstimate();
    if (cartItems.length === 0) return this.renderEmpty();

    return this.renderProducts({
      cartItems,
      cartOrderBy,
      sortItems,
      pricePermission,
      leadTimePermission,
      stockPermission,
      opicCodePermission,
      soneparCodePermission,
      soneparCodeOff,
      fileEmailCsv,
      fileEmailPdf,
      fileEmailXml,
      fileEmailJson,
      companyTag,
      defaultAddress,
      locations,
      clientLocation,
      clientWithdraw,
      defaultAddressOptionSelected,
      clientWithdrawAddressOptionSelected,
      clientWithdrawLockerAddressOptionSelected,
      deliveryAddress,
      deliveryAddressType,
    });
  }
}

const mapStateToProps = state => ({
  companyTag: state.settings.companyTag,
  cartItems: state.cart.items,
  cartOrderBy: state.cart.orderBy,
  cartUser: state.cart.user,
  cartLoaded: state.cart.loaded,
  cartId: state.cart && state.cart.cartId,
  pricePermission: state.contracts.selected && state.contracts.selected.pricePermission,
  leadTimePermission: state.contracts.selected && state.contracts.selected.leadTimePermission,
  stockPermission: !state.contracts.selected || (state.contracts.selected && state.contracts.selected.stockPermission),
  clientDetails: state.contracts.selected && state.contracts.selected.clientDetails,
  opicCodePermission: state.contracts.selected && state.contracts.selected.opicCodePermission,
  soneparCodePermission: state.contracts.selected && state.contracts.selected.soneparCodePermission,
  soneparCodeOff: !!state.settings.soneparCodeOff,
  buttonLabel: state.contracts.selected && state.contracts.selected.clientDetails && state.contracts.selected.clientDetails.buyButtonLabel,
  defaultAddress: state.contracts && state.contracts.selected && state.contracts.selected.defaultAddress,
  freightOn: state.settings.freightOn,
  freightType: state.contracts && state.contracts.selected.clientDetails.freight,
  locations: state.contracts.selected && state.contracts.selected.client && state.contracts.selected.client.locations,
  observation: state.cart.observation,
  clientLocation: state.contracts.selected && state.contracts.selected.clientDetails && state.contracts.selected.clientDetails.location,
  clientWithdraw: state.contracts && state.contracts.selected.clientDetails.clientWithdraw,
  deliveryAddress: state.cart && state.cart.deliveryAddress,
  purchasePermission: state.contracts.selected && state.contracts.selected.purchasePermission,
  deliveryAddressType: state.contracts.selected
    && state.contracts.selected.clientDetails
    && state.contracts.selected.clientDetails.deliveryAddressType,
});

const mapDispatchToProps = dispatch => ({
  sortItems: value => dispatch(cartSortItems(value)),
  cleanItems: () => dispatch(cartCleanItems()),
  getFile: type => dispatch(cartGetFile(type)),
  setObservation: observationText => dispatch(setObservation(observationText)),
  setDeliveryAddress: deliveryAddress => dispatch(setDeliveryAddress(deliveryAddress)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CartPage);
